import { Show } from 'common/components/Show/Show'

import styles from './encounter-message-overlay.module.scss'

type Props = {
  show?: boolean
}

export const EncounterMessageOverlay = ({ show = true }: Props) => {
  return (
    <Show when={show}>
      <div className={styles.overlay}>
        <div className={styles.message}>Please select an encounter</div>
      </div>
    </Show>
  )
}
